import { render } from "./BasePanel.vue?vue&type=template&id=17e72dec"
import script from "./BasePanel.vue?vue&type=script&lang=js"
export * from "./BasePanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__